import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InfoChipSize } from '../info-chip/info-chip.types';
import { MunilyAreaCardData, MunilyAreaCardIconSet, MunilyAreaCardType } from './area-card.types';

@Component({
  selector: 'common-area-card',
  templateUrl: './area-card.component.html',
  styleUrls: ['./area-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaCardComponent implements OnChanges {
  @Input() data!: MunilyAreaCardData;

  /** Si se provee, el botón de menú actúa como trigger de `mat-menu` (definido en el padre). */
  @Input() menuTriggerFor: MatMenu | null = null;

  @Output() select = new EventEmitter<void>();
  @Output() menuClick = new EventEmitter<void>();

  private _descriptionTrustedHtml: SafeHtml;

  get descriptionTrustedHtml(): SafeHtml {
    return this._descriptionTrustedHtml;
  }

  constructor(
    private readonly _sanitizer: DomSanitizer,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this._descriptionTrustedHtml = this._sanitizer.bypassSecurityTrustHtml('');
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this._syncDescriptionHtml();
  }

  private _syncDescriptionHtml(): void {
    const d = this.data;
    if (!d) {
      this._descriptionTrustedHtml = this._sanitizer.bypassSecurityTrustHtml('');
      this._cdr.markForCheck();
      return;
    }
    const raw = String(d.description ?? '').trim();
    this._descriptionTrustedHtml = this._sanitizer.bypassSecurityTrustHtml(raw.length ? d.description : '');
    this._cdr.markForCheck();
  }

  get type(): MunilyAreaCardType {
    return this.data?.type ?? 'picture';
  }

  get showRating(): boolean {
    return this.data?.showRating ?? true;
  }

  get capacityLabel(): string {
    return this.data?.capacityLabel ?? 'Capacidad:';
  }

  get menuIcon(): string {
    return this.data?.menuIcon ?? 'more_vert';
  }

  get menuIconSet(): MunilyAreaCardIconSet {
    return this.data?.menuIconSet ?? 'material-symbols-rounded';
  }

  get showMenuButton(): boolean {
    return this.data?.showMenuButton ?? true;
  }

  /** Compat: `default` (chip antiguo) → `large`; sin valor → `small` (footer area card). */
  chipSizeResolved(size?: InfoChipSize | 'default'): InfoChipSize {
    if (size === 'small') {
      return 'small';
    }
    if (size === 'large' || size === 'default') {
      return 'large';
    }
    return 'small';
  }

  onSelect(): void {
    this.select.emit();
  }

  onMenuClick(): void {
    this.menuClick.emit();
  }

  onMenuButtonOutput(): void {
    if (!this.menuTriggerFor) {
      this.onMenuClick();
    }
  }
}

